import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import IconClose from "../../../Resources/svg/Icons/IconClose";
import FormTitle from "../../../Components/FormElements/FormTitle";
import alert from "../../../Resources/img/icon-alert-yellow.png";
import Loading from "../../../Components/loading";
import UpdateBeneficiaryCard from "./CardsModalSideRV/UpdateBeneficiaryCard";
import UpdateInsuredCard from "./CardsModalSideRV/UpdateInsuredCard";
import RecalculateModalityCard from "./CardsModalSideRV/RecalculateModalityCard";
import ImproveModalityCard from "./CardsModalSideRV/ImproveModalityCard";
import ModalityDetailCard from "./CardsModalSideRV/ModalityDetailCard";
import { useModalSideRV } from "../../../Components/hooks/useModalSideRV";
import { typeModalRV } from "../../../Utils/constants";
const ModalSideRV = ({
  selectedModality,
  selectedBeneficiary,
  selectedAssured,
  data,
  modalData = {},
  title,
  subtitle = "",
  sideActionsRV,
  handleSucessImprovements,
}: any) => {
  const { handleSubmit, register, errors, setValue, reset } = useForm();
  const {
    isOpen,
    handleClose,
    typeMoneyDescriptionList,
    conditionInvalidateList,
    improvedData,
    dataRecalculate,
    errorDate,
    selectDate1,
    showWarning,
    showWarningUserValidation,
    loadingState,
    handleDateChange,
    validateInitialValue,
    handleValidateUser,
    submitAssured,
    submitBeneficiary,
    onSubmitImprovement,
    onSubmitReCalculate,
    saveRecalculated,
    saveImprovement,
  } = useModalSideRV({ data, selectedModality, handleSucessImprovements });

  useEffect(() => {
    reset();
  }, [selectedModality, sideActionsRV, reset]);

  return (
    <div
      className={
        "modal-aside modal-aside-rv modal-aside" + (isOpen ? " is-open" : "")
      }
    >
      <div className={"modal-aside__box"}>
        <div className="modal-aside__close" onClick={handleClose}>
          <span>Cerrar</span>
          <IconClose />
        </div>
        <div className="modal-aside__body">
          <div className="modal-aside__inner_rv">
            <div className="modal-aside__gradient"></div>
            <FormTitle title={title} />
            {subtitle !== "" && <div className="subtitle-form">{subtitle}</div>}
            {sideActionsRV === typeModalRV.DETAIL && (
              <ModalityDetailCard
                selectedModality={selectedModality}
                data={data}
                typeMoneyDescriptionList={typeMoneyDescriptionList}
              />
            )}
            {sideActionsRV === typeModalRV.IMPROVE && (
              <ImproveModalityCard
                selectedModality={selectedModality}
                data={data}
                typeMoneyDescriptionList={typeMoneyDescriptionList}
                handleSubmit={handleSubmit}
                onSubmitImprovement={onSubmitImprovement}
                setValue={setValue}
                register={register}
                errors={errors}
                improvedData={improvedData}
                saveImprovement={saveImprovement}
              />
            )}
            {sideActionsRV === typeModalRV.RECALCULATE && (
              <RecalculateModalityCard
                selectedModality={selectedModality}
                data={data}
                dataRecalculate={dataRecalculate}
                typeMoneyDescriptionList={typeMoneyDescriptionList}
                conditionInvalidateList={conditionInvalidateList}
                errorDate={errorDate}
                selectDate1={selectDate1}
                setValue={setValue}
                register={register}
                errors={errors}
                handleSubmit={handleSubmit}
                onSubmitReCalculate={onSubmitReCalculate}
                handleDateChange={handleDateChange}
                saveRecalculated={saveRecalculated}
                showWarning={showWarning}
                validateInitialValue={validateInitialValue}
              />
            )}
            {sideActionsRV === typeModalRV.UPDATE_INSURED && isOpen && (
              <UpdateInsuredCard
                selectedAssured={selectedAssured}
                showWarningUserValidation={showWarningUserValidation}
                handleValidateUser={handleValidateUser}
                submitAssured={submitAssured}
                isOpen={isOpen}
                alert={alert}
              />
            )}
            {sideActionsRV === typeModalRV.UPDATE_BENEFICIARY && isOpen && (
              <UpdateBeneficiaryCard
                selectedBeneficiary={selectedBeneficiary}
                showWarningUserValidation={showWarningUserValidation}
                handleValidateUser={handleValidateUser}
                submitBeneficiary={submitBeneficiary}
                isOpen={isOpen}
              />
            )}
          </div>
        </div>
      </div>
      {loadingState && <Loading />}
    </div>
  );
};

export default ModalSideRV;
